import { HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";
import { Icon, IconName } from "./Icon";

type Tone = "warn" | "info" | "success" | "danger";

type Props = HTMLAttributes<HTMLDivElement> & {
  tone?: Tone;
  icon?: IconName;
  children: ReactNode;
};

export function Banner({ tone = "info", icon, className, children, ...rest }: Props) {
  return (
    <div className={clsx("tcg-banner", `tcg-banner-${tone}`, className)} {...rest}>
      {icon && <Icon name={icon} size={14} />}
      <div>{children}</div>
    </div>
  );
}
